import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import {
    readLocationsIP,
} from './helpers'
import Modal from '../../components/shared/modal'
import LocationsIPForm from './forms/locations-ip-form'
import { useAppSelector } from '../../hooks/redux'

interface LocationIPEntity {
    uid: string
    name: string
    addressPrefix: string
}

const LocationsIPDevices = () => {
    const { t } = useTranslation()
    const locationsIP = useAppSelector(state => state.superAdmin.locationsIP) as LocationIPEntity[]
    const [modalOpen, setModalOpen] = useState(false)

    useEffect(() => {
        if (!locationsIP || locationsIP.length === 0) {
            readLocationsIP()
        }
        // intentional: locationsIP is only read once on mount to avoid re-fetching when Redux updates the list
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    /**
     * Set locations form modal
     *
     * @param {boolean} open
     */
    const editLocationIP = (open: boolean): void => {
        setModalOpen(open)
    }

    return (
        <div className="container">
            <h1 className="border-bottom border-info pb-2 mb-4">{t('device.locationIPList')}</h1>
            <div className="d-flex justify-content-between align-items-center mb-3">
                <Link to="/devices" className="d-flex align-items-center">
                    <i className="fas fa-arrow-left mr-2" />
                    {t('device.backToDevices')}
                </Link>
                <div
                    className="btn btn-info"
                    onClick={() => editLocationIP(true)}
                >
                    {t('device.addLocationIP')}
                </div>
            </div>

            {locationsIP?.map(locationIP => (
                <div key={locationIP.uid} className="list-group">
                    <div className="list-group-item">
                        <div className="d-flex w-100 flex-row align-items-center justify-content-between">
                            <div>
                                {locationIP.name}
                            </div>
                            <div>
                                {locationIP.addressPrefix}
                            </div>
                        </div>
                    </div>
                </div>
            ))}

            {modalOpen && (
                <Modal
                    description={t('device.locationIP.add')}
                    handleHideModal={() => editLocationIP(false)}
                    content={() => (
                        <LocationsIPForm
                            successSaveFunction={() => editLocationIP(false)}
                            locationsIP={locationsIP}
                        />
                    )}
                />
            )}
        </div>
    )
}

export default LocationsIPDevices
